(function (global) {
  function affCapture(endpoint, opts) {
    if (!endpoint) {
      console.error("affCapture: endpoint is required");
      return;
    }
    opts = opts || {};
    var KEYS = opts.keys || ["awc","gclid","fbclid","ttclid","msclkid"];
    var EXCL = opts.exclude || []; // facultatif

    try {
      if (typeof window === "undefined") return;
      var w = window, d = w.document;
      if (!w.location) return;

      // Exclusions par path
      var path = w.location.pathname || "";
      for (var i=0; i<EXCL.length; i++) {
        if (EXCL[i].test(path)) return;
      }

      // Cherche les clés dans l’URL
      var params = new URLSearchParams(w.location.search || "");
      var present = [];
      for (var j=0; j<KEYS.length; j++) {
        var k = KEYS[j];
        var v = params.get(k);
        if (v) present.push([k, v]);
      }
      if (!present.length) return;

      // Anti-doublon par session
      try {
        var sig = path + "?" + (w.location.search || "");
        if (w.sessionStorage && w.sessionStorage.getItem("__aff_capture_sig") === sig) return;
        if (w.sessionStorage) w.sessionStorage.setItem("__aff_capture_sig", sig);
      } catch(e) {}

      // Construit la query
      var parts = [];
      for (var m=0; m<present.length; m++) {
        parts.push(encodeURIComponent(present[m][0]) + "=" + encodeURIComponent(present[m][1]));
      }
      parts.push("cb=" + Date.now());
      var src = endpoint + "?" + parts.join("&");

      // Pixel 1x1
      var img = new Image(1,1);
      img.referrerPolicy = "strict-origin-when-cross-origin";
      img.src = src;
      (d.body || d.documentElement).appendChild(img);

    } catch (e) {
      console.error("affCapture error", e);
    }
  }

  // expose global
  global.affCapture = affCapture;
  if (typeof module !== "undefined" && module.exports) module.exports = { affCapture: affCapture };
  else if (typeof define === "function" && define.amd) define(function(){ return { affCapture: affCapture }; });

})(typeof window !== "undefined" ? window : this);